import { OppButton } from '../ui/control';
import type React from 'react';

interface OppCourierQuickAction {
  label: string;
  icon: React.ElementType;
  onClick: () => void;
  badgeBg?: string;
  badgeText?: string;
}

export function OppCourierQuickActions({ actions }: { actions: OppCourierQuickAction[] }) {
  return (
    <div className="grid grid-cols-2 gap-2">
      {actions.map((action) => {
        const Icon = action.icon;
        return (
          <OppButton key={action.label} onClick={action.onClick} className="letter-card flex flex-col items-center gap-1.5 rounded-xl px-2 py-3">
            <div className={`flex h-9 w-9 items-center justify-center rounded-lg ${action.badgeBg}`}>
              <Icon className={`h-4 w-4 ${action.badgeText}`} />
            </div>
            <span className="text-caption font-medium text-foreground">{action.label}</span>
          </OppButton>
        );
      })}
    </div>
  );
}
